import { GetDcAllInput, GetDcAllResponse } from 'services/interface'
import { getDcAllList } from 'services/dcApi'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

  
export const useGetDcAllList = (input: GetDcAllInput): UseQueryResult<GetDcAllResponse, Error> => {
  return useQuery<GetDcAllResponse, Error>({
    queryKey: ['getDcAllList', input.province_id, input.limit, input.offset],
    queryFn: () => getDcAllList(input),
    // staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
  })
}
